import { render, staticRenderFns } from "./SizeGuide.vue?vue&type=template&id=80d07418&scoped=true&"
import script from "./SizeGuide.vue?vue&type=script&lang=ts&"
export * from "./SizeGuide.vue?vue&type=script&lang=ts&"
import style0 from "./SizeGuide.vue?vue&type=style&index=0&id=80d07418&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80d07418",
  null
  
)

export default component.exports